import '.a{display:flex;}.ssr-plugin'
import '.l{align-items:center;}.ssr-plugin'
import '.al{gap:0.5rem;}.ssr-plugin'
import '.dg{height:2.5rem;}.ssr-plugin'
import '.d2{justify-content:flex-end;}.ssr-plugin'
import '.c3{position:relative;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ar{cursor:pointer;}.ssr-plugin'
import '.i{width:100%;}.ssr-plugin'
import '.e5{padding-inline:1rem;}.ssr-plugin'
import '.x{justify-content:center;}.ssr-plugin'
import '.d8{position:sticky;}.ssr-plugin'
import '.cn{top:0;}.ssr-plugin'
import '.d9{z-index:10;}.ssr-plugin'
import '.cu{background:var(--shades-white);}.ssr-plugin'
import '.b7{max-width:77.5rem;}.ssr-plugin'
import '.j{justify-content:space-between;}.ssr-plugin'
import { useCallback } from 'react'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Button } from '@app/components/core/button/Button'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { MegaMenu } from '../../megaMenu/MegaMenu.desktop'
import { HoverTabs } from '@app/components/core/tabs/HoverTabs'
import { useAuthModal } from '@app/util/hooks/useAuthModal'
import { TextLink } from '@app/components/core/link/TextLink'
import useTransform from '@app/util/useTransform'
import { pages } from '@app/util/links'
import { ProfileMenu } from '../blocks/ProfileMenu'
import { useLocation } from 'wouter'
import { authTabs } from '../../authentication/authTabs'
import { Image } from '@app/components/core/image/Image'
import { useTranslations } from '@i18n/useLanguage'

export type TopNavBarProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
}

const ACCOUNT_SLOT_WIDTH = '14rem'
const ACCOUNT_APPEAR_ANIMATION = 'nav-account-appear 220ms ease-out'

const AuthButtons = () => {
  const { showAuthModal } = useAuthModal()

  return (
    <div className="a l al"
    >
      <Button
        variant="secondary"
        label="Log in"
        onClick={() => showAuthModal(authTabs.login)}
        style={{
          whiteSpace: 'nowrap',
        }}
      />
      <Button
        variant="primary"
        label="Meld je aan"
        onClick={() => showAuthModal(authTabs.signUp)}
        style={{
          whiteSpace: 'nowrap',
        }}
      />
    </div>
  )
}

export const TopNavBar = ({ userName, avatar, isLoading }: TopNavBarProps) => {
  const translations = useTranslations().app.nav
  const transformStyle = useTransform('center')
  const [, navigate] = useLocation()

  const renderAccountSection = useCallback(() => {
    if (isLoading) {
      return (
        <div className="dg"
          style={{
            width: ACCOUNT_SLOT_WIDTH,}}
        />
      )
    }
    return userName ? (
      <div className="a d2"
        style={{
          width: ACCOUNT_SLOT_WIDTH,
          animation: ACCOUNT_APPEAR_ANIMATION,
        }}
      >
        <ProfileMenu>
          <div className="c3 a b l ar"
          >
            <Avatar
              size="small"
              labelSource={userName}
              image={avatar}
              onClick={() => navigate(pages.dashboard)}
            />
          </div>
        </ProfileMenu>
      </div>
    ) : (
      <div className="a d2"
        style={{
          width: ACCOUNT_SLOT_WIDTH,
          animation: ACCOUNT_APPEAR_ANIMATION,
        }}
      >
        <AuthButtons />
      </div>
    )
  }, [isLoading, userName, avatar, navigate])

  return (
    <div className="i e5 a x d8 cn d9 cu"
    >
      <styled.nav className="cu i b7 a j l"
        style={{
          ...transformStyle,
        }}
      >
        <TextLink
          to={pages.home}
          noHover={true}
          isBold={false}
          hasIcon={false}
          textStyle={{ lineHeight: 0 }}
        >
          <Image src={fullLogo} alt="Crowdbuilding Logo" />
        </TextLink>
        <HoverTabs.Group>
          <HoverTabs.Tab label={translations.find}>
            <MegaMenu variant={'find'} />
          </HoverTabs.Tab>
          <HoverTabs.Tab label={translations.start}>
            <MegaMenu variant={'start'} />
          </HoverTabs.Tab>
          <HoverTabs.Tab label={translations.learn}>
            <MegaMenu variant={'learn'} />
          </HoverTabs.Tab>
          <HoverTabs.Tab label={translations.aboutUs}>
            <MegaMenu variant={'aboutUs'} />
          </HoverTabs.Tab>
        </HoverTabs.Group>
        {renderAccountSection()}
      </styled.nav>
    </div>
  )
}
